var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLookahead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lookahead",
    clipPath: "url(#clip0_3092_5530)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2.04384H1.04384V3.78358H15V2.04384ZM0 1V4.82742H1.33333V13H11.8816L13.6769 14.7953L16.0339 12.4383L13.6769 10.0813L11.7582 12H2.33333V8.33333H3.66667V9.69868H14.1928V5.87126H3.66667V7.33333H2.33333V4.82742H16.0438V1H0ZM13.1489 6.9151H4.71051V8.65483H13.1489V6.9151ZM12.7341 12.4383L13.6769 11.4955L14.6197 12.4383L13.6769 13.3811L12.7341 12.4383Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3092_5530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLookahead);
export default __webpack_public_path__ + "static/media/new_lookahead.89a08367da6bd1fbb0d17fda8f245a2b.svg";
export { ForwardRef as ReactComponent };